/* Mount on the real product after is-land restores it; support theme-editor reloads. */
(() => {
  if (window.KonssyProductLifecycle) return;
  const selector = 'konssy-product-component.konssy-marketplace, .konssy-marketplace[data-local-preview]';
  const features = new Map();
  const unloaded = new WeakSet();
  let frame = 0;
  function ready(root) {
    if (!root.isConnected || unloaded.has(root)) return false;
    for (let node = root.parentElement; node; node = node.parentElement) {
      if (node.localName === 'is-land' && !node.hasAttribute('ready')) return false;
    }
    return true;
  }
  function scan() {
    frame = 0;
    const roots = document.querySelectorAll(selector);
    features.forEach(({mount, instances}) => {
      instances.forEach((dispose, root) => {
        if (!ready(root)) { dispose(); instances.delete(root); }
      });
      roots.forEach(root => {
        if (!ready(root) || instances.has(root)) return;
        const controller = new AbortController();
        const cleanup = mount(root, controller.signal);
        instances.set(root, () => { controller.abort(); cleanup?.(); });
      });
    });
  }
  // is-land sets ready before its promise handlers restore the original node.
  // Scan on the next frame, after those handlers and component setup complete.
  function schedule() { if (!frame) frame = requestAnimationFrame(scan); }
  window.KonssyProductLifecycle = {
    register(name, mount) {
      if (!features.has(name)) features.set(name, {mount, instances:new Map()});
      schedule();
    }
  };
  const relevant = node => node.nodeType === 1 &&
    (node.matches('.konssy-marketplace, is-land') || node.querySelector('.konssy-marketplace, is-land'));
  new MutationObserver(records => {
    if (records.some(record => record.type === 'attributes' ||
      [...record.addedNodes, ...record.removedNodes].some(relevant))) schedule();
  }).observe(document.documentElement, {childList:true, subtree:true, attributes:true, attributeFilter:['ready']});
  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('product-component:loaded', schedule);
  document.addEventListener('shopify:section:load', event => {
    document.querySelectorAll(selector).forEach(root => { if (event.target.contains(root)) unloaded.delete(root); });
    schedule();
  });
  document.addEventListener('shopify:section:unload', event => {
    features.forEach(({instances}) => instances.forEach((dispose, root) => {
      if (event.target.contains(root)) { unloaded.add(root); dispose(); instances.delete(root); }
    }));
  });
})();
